module.exports = __webpack_public_path__ + "static/media/naivecontent.e4e44e42.jpeg";